module.exports = __webpack_public_path__ + "img/65.3ea61cdb.png";